import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CustomerOrderPage } from './features/customer/CustomerOrderPage';
import { MarketPage } from './features/market';
import { OfflineIndicator } from '@paulownia/shared';
import { MerchantPortal } from './features/portal/MerchantPortal';
import { useAppUpdate } from './hooks/useAppUpdate';
import { initCustomerAuth } from './lib/customer-auth';
import { CurrentMarketProvider } from './contexts/CurrentMarketContext';
import { CartProvider } from './contexts/CartContext';

export default function App() {
  // Check for app updates on iOS PWA
  useAppUpdate();

  // Initialize anonymous auth for customer order tracking
  useEffect(() => {
    initCustomerAuth().catch((error) => {
      console.error('Failed to initialize customer auth:', error);
    });
  }, []);

  return (
    <CurrentMarketProvider>
      <CartProvider>
        <div className="h-screen overflow-hidden bg-gray-50">
          <Routes>
            <Route path="/market/:marketId" element={<MarketPage />} />
            <Route path="/:slug" element={<CustomerOrderPage />} />
            <Route path="/" element={<MerchantPortal />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <OfflineIndicator />
        </div>
      </CartProvider>
    </CurrentMarketProvider>
  );
}
